import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Specialty: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_8452_15734"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <path d="M0 0H14V14H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_8452_15734)">
        <path
          d="M13.4531 5.92412L7 0.546509L0.546875 5.92412V13.4528H6.72656"
          stroke="currentColor"
          strokeWidth="1.1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2271 8.82098C10.2271 8.82098 10.7691 8.00354 11.8403 8.00354C12.7954 8.00354 13.4536 8.84275 13.4536 9.82007C13.4536 10.9513 12.5564 12.2898 10.2271 13.4531C7.89772 12.2898 7.00049 10.9513 7.00049 9.82007C7.00049 8.84275 7.65871 8.00354 8.61377 8.00354C9.68499 8.00354 10.2271 8.82098 10.2271 8.82098Z"
          stroke="currentColor"
          strokeWidth="1.1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
})

Specialty.displayName = 'Specialty'
